import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";   // ✅ import from constants.js

//web backup Customer Complaint Form
export default function CustomerComplaintForm() {
  const [orderId, setOrderId] = useState("");
  const [phone, setPhone] = useState("");
  const [category, setCategory] = useState("");
  const [complaint, setComplaint] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [showForm, setShowForm] = useState(false);   // ✅ toggle for button
  const navigate = useNavigate();

  useEffect(() => {
    const tawkScript = document.createElement("script");
    tawkScript.src = "https://embed.tawk.to/687b925c3d9d30190be7aa6f/1j0hb7ehl";
    tawkScript.async = true;
    tawkScript.charset = "UTF-8";
    tawkScript.setAttribute("crossorigin", "*");

    document.body.appendChild(tawkScript);

    return () => {
      document.body.removeChild(tawkScript);
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, []);

  const handleSubmit = async () => {
    if (!phone || !complaint || !category || !orderId) {
      alert("⚠️ Please fill all fields including Order ID.");
      return;
    }

    try {
      // ✅ Get existing records
      const res = await fetch(AIRTABLE_URL, { headers: AIRTABLE_HEADERS });
      const data = await res.json();
      const records = data.records.map(record => ({
        id: record.id,
        ...record.fields
      }));

      const existing = records.find(
        (row) =>
          row.orderId?.trim() === orderId.trim() &&
          row.phone?.trim() === phone.trim()
      );

      if (!existing) {
        alert("❌ Order not found. Please check Order ID and Phone.");
        return;
      }

      let updateFields = {};
      const assignPhone = existing.assignedTechnicianPhone || "";

      if (!existing.complaintStatus?.trim()) {
        updateFields = {
          complaint,
          complaintCategory: category,
          complaintStatus: "Pending",
          complaintResponse: "",
          phone,
          assignedTechnicianPhone: assignPhone,
        };
      } else if (existing.complaintStatus?.trim() === "Pending") {
        alert("❌ Your first complaint is still pending. Please wait for resolution.");
        return;
      } else if (
        existing.complaintStatus?.trim() === "Resolved" &&
        !existing.complaintStatusAgain?.trim()
      ) {
        updateFields = {
          complaintAgain: complaint,
          complaintCategoryAgain: category,
          complaintStatusAgain: "Pending",
          complaintResponseAgain: "",
          phone,
          assignedTechnicianPhone: assignPhone,
        };
      } else if (existing.complaintStatusAgain?.trim() === "Pending") {
        alert("❌ Your second complaint is still pending. Please wait for resolution.");
        return;
      } else if (
        existing.complaintStatus?.trim() === "Resolved" &&
        existing.complaintStatusAgain?.trim() === "Resolved" &&
        !existing.complaintStatusAgain3?.trim()
      ) {
        updateFields = {
          complaintAgain3: complaint,
          complaintCategoryAgain3: category,
          complaintStatusAgain3: "Pending",
          complaintResponseAgain3: "",
          phone,
          assignedTechnicianPhone: assignPhone,
        };
      } else if (existing.complaintStatusAgain3?.trim() === "Pending") {
        alert("❌ Your third complaint is still pending. Please wait for resolution.");
        return;
      } else {
        alert("✅ All 3 complaints resolved. Please book new service for further help.");
        return;
      }

      // ✅ Update Airtable row
      const patchResponse = await fetch(`${AIRTABLE_URL}/${existing.id}`, {
        method: "PATCH",
        headers: AIRTABLE_HEADERS,
        body: JSON.stringify({ fields: updateFields }),
      });

      const result = await patchResponse.json();

      if (patchResponse.ok) {
        console.log("✅ Airtable PATCH successful:", result);
        alert("✅ Complaint submitted successfully.");
        setSubmitted(true);
      } else {
        console.error("❌ PATCH Failed. Full response:", result);
        alert(`⚠️ Airtable Error: ${result.error?.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("🚫 Catch Error:", err);
      alert("🚫 Network error. Please try again.");
    }
  };

  return (
  <div style={{ padding: 30 }}>
    {/* ✅ Requirement Section (Support Info) */}
    <h2>How can we help you</h2>
    <p>If you face any issue, you can contact us using the details below. If you have booked a service, you can also raise a query using the button below.</p>
    <p><b>Email:</b> coolfixd@gmail.com</p>
    <p><b>Phone:</b> +91-9654261153</p>
    <p><b>Website:</b> https://coolfixd.netlify.app/</p>

    {/* ✅ Toggle Button */}
    <button
      onClick={() => setShowForm(!showForm)}
      style={{
        backgroundColor: showForm ? "#c0392b" : "#27ae60",
        color: "white",
        padding: "10px 20px",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        marginTop: "20px"
      }}
    >
      {showForm ? "Close Query Form" : "Raise a Query"}
    </button>

    {/* ✅ Show complaint form only after button click */}
    {showForm && (
      <>
        <h2> Raise a Complaint</h2>

        <input
          type="text"
          placeholder=" Order ID"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
          style={{ width: "100%", padding: 10, marginBottom: 10 }}
        />
        <input
          type="tel"
          maxLength={10}
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          inputMode="numeric"
          pattern="[0-9]*"
          style={{ width: "100%", padding: 10, marginBottom: 10 }}
        />
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ width: "108%", padding: 10, marginBottom: 10 }}
        >
          <option value="">-- Select Issue Category --</option>
          <option value="Service Issue">Service Issue</option>
          <option value="Technician Issue">Technician Issue</option>
          <option value="Payment Issue">Payment Issue</option>
          <option value="Other">Other</option>
        </select>
        <textarea
          placeholder=" Describe the issue..."
          value={complaint}
          onChange={(e) => setComplaint(e.target.value)}
          style={{ width: "100%", padding: 10, height: 100 }}
        />

        <button
          onClick={handleSubmit}
          style={{
            marginTop: 10,
            backgroundColor: "#2980b9",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Submit Complaint
        </button>

        <br />
        <br />
        <button
          onClick={() => navigate("/view-complaints")}
          style={{
            backgroundColor: "#2980b9",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          View Complaints
        </button>

        {submitted && (
          <p style={{ marginTop: 20, color: "green" }}>
            ✅ Complaint submitted successfully for: <b>{phone}</b>
          </p>
        )}
      </>
    )}
  </div>
);
}
